// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".log-body[data-v-16dba71a] {\n  width: calc(100% - 40px);\n  height: 100%;\n  margin: 20px auto 20px;\n}\n", ""]);
// Exports
module.exports = exports;
